import { c as _c } from "react/compiler-runtime";
import PricePlanBase from 'modules/digital-product/price-plans/components/price-plan-base';
import PricePlanTooltip from 'modules/digital-product/price-plans/components/price-plan-tooltip';
import { PricePlanType } from '@systemeio/types';
import React, { FC } from 'react';
interface Props {
  pricePlans: PricePlanType[];
}
export const PricePlansReadOnly: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    pricePlans
  } = t0;
  let t1;
  if ($[0] !== pricePlans) {
    t1 = pricePlans.map(_temp);
    $[0] = pricePlans;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <PricePlanBase>{t1}</PricePlanBase>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(pricePlan) {
  return <div key={pricePlan.id} className="border-text-secondary/30 flex w-full items-center justify-between rounded-lg border p-2"><div className="bo-color-[rgb(var(--brand-primary-subtle))] flex flex-col gap-3"><PricePlanTooltip pricePlan={pricePlan} label={<div className="text-brand-primary flex flex-row items-center gap-1 text-sm lg:text-[15px]"><span>{pricePlan.innerName || "test.price.plan.name"}</span></div>} /></div></div>;
}